export function OutlineUserEditIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.98409 11.0701C12.2145 11.0701 14.0226 9.26358 14.0226 7.03507C14.0226 4.80656 12.2145 3 9.98409 3C7.75367 3 5.94556 4.80656 5.94556 7.03507C5.94556 9.26358 7.75367 11.0701 9.98409 11.0701Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.97576 14.1016H4.93237C3.81729 14.1016 2.91553 15.0026 2.91553 16.1167V21.1641H5.94564"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7902 13.3142L16.9346 10.4609L11.2198 16.1708L14.0755 19.024L19.7902 13.3142Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5023 9.74326L20.5057 9.74668C21.2942 10.5345 21.2942 11.8087 20.5057 12.5965L19.7892 13.3124L16.9336 10.4591L17.65 9.74326C18.4385 8.95545 19.7138 8.95545 20.5023 9.74326Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6459 20.452L9.07764 21.1641L9.79032 17.5941L11.2205 16.1699L14.0761 19.0231L12.6459 20.452Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
